// const parentDiv = document.querySelector('.variant-picker__option-values');
// const childDiv = parentDiv.querySelector('.saet-3-stk');

// if (childDiv) {
//     parentDiv.classList.add('has-saet-3-stk');
// }


//    $('select#changeAll').on('change', function() {
//     var val_ = $('#changeAll :selected').text();
//     $('.child-changed option').map(function() {
//      $(this).text(val_);
//       $(this).value=val_;
//     });
// });

$( document ).ready(function() {

  $('.swiper-wrapper').slick({
        dots: false,
        arrows: false,
        infinite: true,
        slidesToShow: 5,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 0,
        speed: 5000,
        cssEase: 'linear',
        responsive: [
          {
            breakpoint: 1320,
            settings: {
              slidesToShow: 5,
              speed: 2000,
              slidesToScroll: 4
            }
          },
          {
            breakpoint: 1080,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 3
            }
          },
          {
            breakpoint: 680,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
          }
        }]
      });
  
  $('.customer-review-section .customer-review-main .customer_review_item-wrapper').slick({
      dots: false,
      arrows: true,
      infinite: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
        }
      }]
  });
     
  $('.index-customer-review-section .customer-review-main .customer_review_item-wrapper').slick({
      dots: false,
      arrows: true,
      infinite: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
        }
      }]
  });
  
  // $(document).on('click', '.color-swatch', function () {
  //   console.log('clllc colr');
  //   var color = $(this).attr('data-value') || '';
  //   $('.product-gallery__thumbnail').each(function () {
  //     var dataColor = $(this).find('img').attr('data-color') || '';
  //     $(this).toggle(dataColor.includes(color));
  //   });
  // });

  // var already = $('.sr-only[checked="checked"] + label').attr('data-value');
  // $('.product-gallery__thumbnail img').each(function(){
  //       if($(this).attr('data-color').includes(already)){
  //         $(this).closest('.product-gallery__thumbnail').show();
  //       }
  //       else{
  //         $(this).closest('.product-gallery__thumbnail').hide();
  //       }
  //  });   

  $(document).on('click', '.color-swatch, .thumbnail-swatch', function () {
    console.log('clllc colr');
    var color = $(this).attr('data-color-key') || '';
    $('.product-gallery__thumbnail[data-media-type="image"]').each(function () {
      var dataColor = $(this).find('img').attr('data-color') || '';
      $(this).toggle(dataColor.includes(color));
    });
  });

  var already = $('.sr-only[checked="checked"] + label').attr('data-color-key');
  $('.product-gallery__thumbnail[data-media-type="image"] img').each(function(){
      if($(this).attr('data-color').includes(already)){
        $(this).closest('.product-gallery__thumbnail[data-media-type="image"]').show();
      }
      else{
        $(this).closest('.product-gallery__thumbnail[data-media-type="image"]').hide();
      }
   });  

  var data_market = $('html').attr('current-domain-UC'); 
  function filterProductVideosBydomain(data_market) {
    const currentMarket = data_market;
    const allItems = document.querySelectorAll('.video-product-gallery__thumbnail[data-media-alt-downcase]');
    let hasMatch = false;

    allItems.forEach(item => {
      if (item.getAttribute('data-media-alt-downcase') === currentMarket) {
        item.style.display = '';
        hasMatch = true;
      } else {
        item.style.display = 'none';
      }
    });

    // If no match found, show all
    // if (!hasMatch) {
    //   allItems.forEach(item => {
    //     item.style.display = '';
    //   });
    // }

    // If no match found, hide all
    if (!hasMatch) {
      allItems.forEach(item => {
        item.style.display = 'none';
      });
    }
  }
  
  filterProductVideosBydomain(data_market);
  
});

$(document).ready(function() {
    var currentDomain = window.location.hostname;
    
    if (currentDomain === "journeylife.dk") {
        $(".icon-flag").contents().filter(function() {
            return this.nodeType === 3;
        }).each(function() {
            if($.trim(this.nodeValue) === "Dansk brand") {
                this.nodeValue = "Dansk brand";
            }
        });
    } else if (currentDomain === "journeylife.se") {
        $(".icon-flag").contents().filter(function() {
            return this.nodeType === 3;
        }).each(function() {
            if($.trim(this.nodeValue) === "Dansk brand") {
                this.nodeValue = "Danskt varumärke";
            }
        });
    }
});

$(document).ready(function() {
    // Get the value of the lang attribute
    var langAttributeValue = $('html').attr('lang');
    if (langAttributeValue == 'da'){
      <!--Start of Tawk.to Script-->
      var Tawk_API=Tawk_API||{}, Tawk_LoadStart=new Date();
      (function(){
      var s1=document.createElement("script"),s0=document.getElementsByTagName("script")[0];
      s1.async=true;
      s1.src='https://embed.tawk.to/647dd12ccc26a871b020b6c6/1h25ni5ur';
      s1.charset='UTF-8';
      s1.setAttribute('crossorigin','*');
      s0.parentNode.insertBefore(s1,s0);
      })();
      <!--End of Tawk.to Script-->
    }else if(langAttributeValue == 'sv'){
      var Tawk_API=Tawk_API||{}, Tawk_LoadStart=new Date();
      (function(){
      var s1=document.createElement("script"),s0=document.getElementsByTagName("script")[0];
      s1.async=true;
      s1.src='https://embed.tawk.to/647dd12ccc26a871b020b6c6/1hr4cgl86';
      s1.charset='UTF-8';
      s1.setAttribute('crossorigin','*');
      s0.parentNode.insertBefore(s1,s0);
      })();
    }else if(langAttributeValue == 'nl'){
      <!--Start of Tawk.to Script-->
      var Tawk_API=Tawk_API||{}, Tawk_LoadStart=new Date();
      (function(){
      var s1=document.createElement("script"),s0=document.getElementsByTagName("script")[0];
      s1.async=true;
      s1.src='https://embed.tawk.to/647dd12ccc26a871b020b6c6/1iosipr5p';
      s1.charset='UTF-8';
      s1.setAttribute('crossorigin','*');
      s0.parentNode.insertBefore(s1,s0);
      })();
      <!--End of Tawk.to Script-->
    }
    else if(langAttributeValue == 'no'){
      <!--Start of Tawk.to Script-->
      var Tawk_API=Tawk_API||{}, Tawk_LoadStart=new Date();
      (function(){
      var s1=document.createElement("script"),s0=document.getElementsByTagName("script")[0];
      s1.async=true;
      s1.src='https://embed.tawk.to/647dd12ccc26a871b020b6c6/1k2fho6d0';
      s1.charset='UTF-8';
      s1.setAttribute('crossorigin','*');
      s0.parentNode.insertBefore(s1,s0);
      })();
      <!--End of Tawk.to Script-->
    }
    else if(langAttributeValue == 'de'){
      <!--Start of Tawk.to Script-->
      var Tawk_API=Tawk_API||{}, Tawk_LoadStart=new Date();
      (function(){
      var s1=document.createElement("script"),s0=document.getElementsByTagName("script")[0];
      s1.async=true;
      s1.src='https://embed.tawk.to/647dd12ccc26a871b020b6c6/1jrq8oj7j';
      s1.charset='UTF-8';
      s1.setAttribute('crossorigin','*');
      s0.parentNode.insertBefore(s1,s0);
      })();
      <!--End of Tawk.to Script-->
    }
});

$(document).ready(function() {
    // var domain = window.location.hostname;
  var data_market = $('html').attr('current-domain-UC'); 
  if (data_market === "SE") {
    $("#mobilepay-icon, #dankort-icon, #anyday-icon").hide();
  }
    
  // $('variant-picker.variant-picker fieldset.variant-picker__option .variant-picker__option-values input').change(function(){
  //   filterProductVideosBydomain(data_market);
  // });


  document.querySelectorAll('.shopify-section--blog-posts').forEach(function(section){
    const posts = section.querySelectorAll('.blog-post-card');
    // const hiddenPosts = section.querySelectorAll('.blog-post-card .hide-seveden-post');
    const hiddenPosts = section.querySelectorAll(
      '.blog-post-card.hidden'
    );
    // agar sabhi post items me hide-seveden-post class hai
    if(posts.length > 0 && posts.length === hiddenPosts.length){
        section.style.display = 'none';
    }
  });

});


